import React, { useState, useEffect, useRef } from 'react';

/*
 * Reset password
 */

import RubyLogoNavy from './images/ruby-logo-navy.svg';
import { useDispatch } from 'react-redux';
import * as coreActions from './core/actions';
import './fonts/Sofia.ttf';
import './fonts/Sofia-bold.ttf';
import styles from './PasswordScreens.module.css';



function PasswordReset(props) {
  const digitRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const codeSubmitRef = useRef();
  const [busy, setBusy] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [email, setEmail] = useState('');
  const [alert, setAlert] = useState({show: false, text: ''});
  const [digits, setDigits] = useState('      ');
  const [activeDigit, setActiveDigit] = useState(0);
  const dispatch = useDispatch();
  const valid = email.length > 0;
  const codeValid = digits.replace(/[^\d]/g, '').length === 6;
  document.body.style = 'background: #f4cac;';

  

  function sendCode(event) {
    event.preventDefault();
    setAlert({show: false, text: ''});
    setBusy(true);
    dispatch(coreActions.sendPasswordResetCode(undefined, email,
                                               () => {
                                                 setBusy(false);
                                                 setCodeSent(true);
                                               }, (error, status, content) => {
                                                 dispatch(coreActions.setSnackMessageQueue([]));
                                                 setAlert({show: true, text: error});
                                                 setBusy(false);
                                               }));
  }
  
  function resetPassword(event) {
    event.preventDefault();
    setAlert({show: false, text: ''});
    setBusy(true);
    dispatch(coreActions.resetPassword(undefined, email, digits,
                                       () => {
                                         dispatch(coreActions.cancelPasswordReset());
                                       }, (error, status, content) => {
                                         setAlert({show: true, text: error});
                                         setBusy(false);
                                       }));
  }

  useEffect(() => {
    if (codeSent) {
      if (codeValid) {
        codeSubmitRef.current.focus();        
      } else {
        digitRefs[activeDigit].current.focus();
      }
    }
  });

  function setDigit(event, pos) {
    /* Delete */
    if (event.target.value.length === 0) {
      let newDigits = digits.slice(0, pos) + digits.slice(pos+1, 6);
      setDigits(newDigits.padEnd(6, ' '));
      setActiveDigit(pos > 0 ? pos - 1 : 0);
    }
    
    let insertString=event.target.value.replace(/[^\d]/g, '');
    
    /* 1 = insert single at pos and move to next */
    if (insertString.length === 1) {
      let newDigits = digits.slice(0, pos) + insertString + digits.slice(pos+1, 6);
      setDigits(newDigits.slice(0, 6));
      setActiveDigit(pos < 5 ? pos + 1 : 5);
    }
    /* 2 = Replace character at pos */
    if (insertString.length === 2) {
      /* Handle both typing the new after or before the old */
      let newDigits = digits.slice(0, pos) + insertString[1] + digits.slice(pos+1, 6);      
      if (digits[pos] === insertString[1]) {
        newDigits = digits.slice(0, pos) + insertString[0] + digits.slice(pos+1, 6);
      }
      setDigits(newDigits.slice(0, 6));
      setActiveDigit(pos < 5 ? pos + 1 : 5);
    }

    /* More than two assume a paste so keep all */
    if (insertString.length > 2) {
      let newDigits = digits.slice(0, pos) + insertString + digits.slice(pos+1, 6);
      let justDigits = newDigits.replace(/[^\d]/g, '');
      console.log(justDigits);
      if (justDigits.length <= 5) {
        setActiveDigit(justDigits.length);
      } else {
        setActiveDigit(5);
      }
      setDigits(newDigits.slice(0, 6));
    }

  }
  
  if (codeSent) {
    return(
      <React.Fragment>
        <div className={styles.container}>
          <div className={styles.topSection}>
            <div className={styles.logo}>
              <img alt="Ruby Logo" src={RubyLogoNavy} />
            </div>
            <div className={styles.form}>
              <form>
                <div className={styles.alert}
                     style={{ display: alert.show ? 'block' : 'none' }}>
                  {alert.text}
                </div>
                <div className={styles.title}>
                  Enter the code you received and click reset password. It will take you back to the login screen
                  and email a new password.
                </div>
                <div className={styles.code}>
                  <input className={styles.codeDigit} type="text"
                         ref={digitRefs[0]}
                         overflow="hidden"
                         autoComplete="off"
                         value={digits[0]} onChange={(event) => setDigit(event, 0)}/>
                  <input className={styles.codeDigit} type="text"
                         autoComplete="off"
                         overflow="hidden"
                         ref={digitRefs[1]}                  
                         value={digits[1]} onChange={(event) => setDigit(event, 1)}/>
                  <input className={styles.codeDigit} type="text"
                         autoComplete="off"
                         overflow="hidden"
                         ref={digitRefs[2]}
                         value={digits[2]} onChange={(event) => setDigit(event, 2)}/>
                  <input className={styles.codeDigit} type="text"
                         autoComplete="off"
                         overflow="hidden"
                         ref={digitRefs[3]}
                         value={digits[3]} onChange={(event) => setDigit(event, 3)}/>
                  <input className={styles.codeDigit} type="text"
                         autoComplete="off"
                         overflow="hidden"
                         ref={digitRefs[4]}
                         value={digits[4]} onChange={(event) => setDigit(event, 4)}/>
                  <input className={styles.codeDigit} type="text"
                         autoComplete="off"
                         overflow="hidden"
                         ref={digitRefs[5]}
                         value={digits[5]} onChange={(event) => setDigit(event, 5)}/>
                </div>
                <div>
                  <button disabled={!codeValid || busy}
                          ref={codeSubmitRef}
                          onClick={resetPassword}>Reset Password</button>
                  <button
                    onClick={() => dispatch(coreActions.cancelPasswordReset())}>
                    Cancel</button>
                </div>
              </form>
            </div>
            
          </div>
          <div className={styles.footerSection}>
            <p className={styles.contact}>
              Questions? Contact us at <a href="tel:(866) 611-7829">866-611-7829</a> or <a href="mailto:staff@ruby.com">staff@ruby.com</a> </p>
          </div>
        </div>
      </React.Fragment>);
  } else {
    return(
      <React.Fragment>
        <div className={styles.container}>
          <div className={styles.topSection}>
            <div className={styles.logo}>
              <img alt="Ruby Logo" src={RubyLogoNavy} />
            </div>
            <div className={styles.form}>
              <form>
                <div className={styles.alert}
                     style={{ display: alert.show ? 'block' : 'none' }}>
                  {alert.text}
                </div>
                <div className={styles.title}>
                  To reset your password, enter the email you use for logins.
                </div>
                <div className={styles.title}>
                  A verification code will be sent to that email.
                </div>
                <div>
                  <span className={styles.accent}>*</span>
                  <label>Email</label>
                </div>
                <input type="text"
                       value={email}
                       autoComplete="email"
                       onChange={(event) => setEmail(event.target.value)}
                       name="Email" />
                <div>
                  <button disabled={!valid || busy}
                          onClick={sendCode}>Send Code</button>
                  <button
                    onClick={() => dispatch(coreActions.cancelPasswordReset())}>
                    Cancel</button>
                </div>
              </form>
            </div>
            
          </div>
          <div className={styles.footerSection}>
            <p className={styles.contact}>
              Questions? Contact us at <a href="tel:(866) 611-7829">866-611-7829</a> or <a href="mailto:staff@ruby.com">staff@ruby.com</a> </p>
          </div>
        </div>
      </React.Fragment>);
    }
}

export default PasswordReset;
